<template>
    <div>
        <div class="callout callout-danger" v-if="!allowed">
            <p>{{ $t('pages.url-shortener.not_allowed') }}</p>
        </div>

        <page-card :header="$t('pages.url-shortener.title')" v-if="allowed">
            <b-row>
                <b-col>
                    <table class="table table-striped" v-if="hasPaths">
                        <thead>
                        <tr>
                            <th>{{ $t('pages.url-shortener.shortcut') }}</th>
                            <th>{{ $t('pages.url-shortener.url') }}</th>
                            <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="path of paths">
                            <td><a :href="path.url" target="_blank" class="btn btn-block"
                                   :class="{
                                'disabled': !path.enabled,
                                'btn-success': path.enabled,
                                'btn-dark':!path.enabled}">{{ path.shortcut }}</a>
                            </td>
                            <td>
                                <a :href="path.url" target="_blank">{{ path.url }}</a>
                                <p class="small text-danger" v-if="!path.enabled">
                                    {{ $t('pages.url-shortener.hints.not_yet_enabled') }}
                                </p>
                            </td>
                            <td><a href="#" v-on:click="setPathToBeDeleted(path.id, path.shortcut)"
                                   v-b-tooltip.hover :title="$t('pages.url-shortener.delete')"
                                   v-b-modal.modalDeleteUrlShortener
                                   class="btn btn-danger"><i
                                class="fas fa-trash"></i></a>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="3">
                    <b-button class="mt-2" variant="primary" v-b-modal.modalCreateUrlShortener>
                        <b-icon-plus aria-hidden="true"/>
                        {{ $t('pages.url-shortener.create') }}
                    </b-button>
                </b-col>
            </b-row>

        </page-card>

        <b-modal id="modalCreateUrlShortener"
                 :title="$t('pages.url-shortener.create')"
                 title-tag="h3"
                 :ok-title="$t('common.confirmation')"
                 :cancel-title="$t('common.cancel')"
                 @cancel="resetNewPath()"
                 @ok="createPath">

            <div>
                <b-form-group :description="$t('pages.url-shortener.hints.shortcut')">
                    <b-input-group :prepend="$t('pages.url-shortener.shortener_base_url')">
                        <b-form-input id="shortcut" v-model="newPath.shortcut"></b-form-input>
                    </b-input-group>
                </b-form-group>
                <div class="pb-1 pt-1">&nbsp;</div>
                <b-form-group :description="$t('pages.url-shortener.hints.url')">
                    <b-input-group :prepend="$t('pages.url-shortener.url')">
                        <b-form-input id="url" v-model="newPath.url"></b-form-input>
                    </b-input-group>
                </b-form-group>
            </div>
        </b-modal>

        <b-modal id="modalDeleteUrlShortener"
                 :title="$t('pages.url-shortener.delete')"
                 title-tag="h3"
                 :ok-title="$t('common.confirmation')"
                 :cancel-title="$t('common.cancel')"
                 @ok="deletePath(deletablePath.id)">

            <div>
                {{ $t('pages.url-shortener.confirm_deletion', {shortcut: deletablePath.shortcut}) }}
            </div>
        </b-modal>

    </div>
</template>

<script>
import GenericNotification from "../layout/GenericNotification";
import LoadingInjector from "../../mixins/LoadingInjector";
import PageCard from "../layout/PageCard";
import Callout from "../layout/Callout";

export default {
    name: "url-shortener",
    mixins: [
        LoadingInjector
    ],
    components: {
        GenericNotification,
        PageCard,
        Callout,
    },
    props: {
        rzaccount: null,
    },
    data: function () {
        return {
            paths: {},
            allowed: false,
            newPath: {
                shortcut: null,
                url: null,
                rzaccount: this.rzaccount,
            },
            deletablePath: {
                shortcut: null,
                id: null,
            }
        }
    },
    created() {
        console.log(`Mouted ${this.$options.name}.`);
        this.permitted();
    },
    watch: {},
    computed: {
        hasPaths: function () {
            return this.paths.length > 0;
        }
    },
    methods: {
        permitted: function () {
            let url = this.$Bologna.secure_url(`/v1/url-shortener/allowed/${this.rzaccount}`);
            this.$http.get(url)
                .then(response => {
                    let x = response.data.data.allowed;
                    this.allowed = (x === undefined) ? false : x;
                    this.fetchPaths();
                })
                .catch(err => {
                    this.allowed = false;
                    this.errorHandler(err);
                })
        },
        fetchPaths: function () {
            if (!this.allowed) {
                return;
            }

            let url = this.$Bologna.secure_url(`/v1/url-shortener/get/${this.rzaccount}`);
            this.$http.get(url)
                .then(response => {
                    let x = response.data.data.paths.map((path) => {
                        return {
                            'id': path.id,
                            'shortcut': this.$purify.sanitize(path.shortcut),
                            'url': this.$purify.sanitize(path.url),
                            'enabled': path.enabled === 1,
                        }
                    });
                    this.paths = (x === undefined) ? {} : x;

                })
                .catch(err => {
                    this.errorHandler(err);
                })
        },
        createPath: function () {
            let url = this.$Bologna.secure_url(`/v1/url-shortener/create`);
            this.$http.post(url, this.newPath)
                .then(response => {

                })
                .catch(err => {

                })
                .finally(() => {
                    this.newPath = {
                        shortcut: null,
                        url: null,
                        rzaccount: this.rzaccount,
                    };
                    this.fetchPaths();
                })
        },
        setPathToBeDeleted: function (id, shortcut) {
            this.deletablePath = {
                shortcut: shortcut,
                id: id,
            };
        },
        deletePath: function (id) {
            let url = this.$Bologna.secure_url(`/v1/url-shortener/delete/${id}`);
            this.$http.post(url, {})
                .then(response => {

                })
                .catch(err => {

                })
                .finally(() => {
                    this.fetchPaths();
                })
        },
        resetNewPath: function () {
            this.newPath = {
                shortcut: null,
                url: null,
                rzaccount: this.rzaccount,
            };
        }
    }
};
</script>
